import { Injectable } from '@angular/core';

@Injectable()
export class JwtStorageService {
    private JWT_SESSION_COOKIE_KEY = 'jwt_token';
    get(): string {
        return localStorage.getItem(this.JWT_SESSION_COOKIE_KEY);
    }
    set(token: string): void {
        localStorage.setItem(this.JWT_SESSION_COOKIE_KEY, token);
    }
    delete(): void {
        localStorage.removeItem(this.JWT_SESSION_COOKIE_KEY);
    }
}
